import React from 'react'
import styles from './NoScrollLayout.scss'
import { GlobalNav } from 'common/GlobalNav'
import { base } from 'lib/styleguide/base.scss'
import cx from 'classnames'

export class NoScrollLayout extends React.PureComponent {
  render () {
    const { children } = this.props
    return (
      <div className={cx(styles.NoScrollLayout, base)}>
        <GlobalNav />
        <div className={styles.content}>
          {children}
        </div>
      </div>
    )
  }
}
